var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-component"},[_c('i',{class:_vm.icon,attrs:{"aria-hidden":"true"}}),_c('h4',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t('NO_DATA_FOR_PREVIEW')))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }